import script from "./articleItem.vue?vue&type=script&setup=true&lang=js"
export * from "./articleItem.vue?vue&type=script&setup=true&lang=js"

import "./articleItem.vue?vue&type=style&index=0&id=4127365c&scoped=true&lang=css"

import exportComponent from "/Users/aiden/Desktop/hujian/hongyu/edu-web-mobile/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4127365c"]])

export default __exports__